import styled from "styled-components";
import box from "components/shared/tokens/box";
import grey from "components/shared/tokens/color/grey";
import red from "components/shared/tokens/color/red";
import { zSpacing } from "components/shared/tokens/spacing";
import { fontFamilies, fontSizes } from "components/shared/tokens/typography";

export const FeatureContainer = styled.div`
  min-height: 100vh;
  background: #f5f7fb;
  display: flex;
  justify-content: center;
  padding: ${zSpacing.z4} ${zSpacing.z3};
  box-sizing: border-box;
`;

export const FeatureCard = styled.div`
  width: 100%;
  max-width: 640px;
  min-height: 320px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: ${box.shadow.z4};
  padding: ${zSpacing.z4};
  box-sizing: border-box;
`;

export const PlaceholderBackButton = styled.button`
  border: 0;
  background: transparent;
  color: ${red.z500};
  display: inline-flex;
  align-items: center;
  gap: ${zSpacing.z2};
  padding: 0;
  margin-bottom: ${zSpacing.z6};
  cursor: pointer;
  font-family: ${fontFamilies.semiBold};
  font-size: ${fontSizes.z300};
`;

export const FeatureIcon = styled.img`
  width: 96px;
  height: 96px;
  display: block;
  margin-bottom: ${zSpacing.z4};
`;

export const FeatureTitle = styled.div`
  color: #293142;
  font-family: ${fontFamilies.bold};
  font-size: ${fontSizes.z600};
  line-height: 1.2;
  margin-bottom: ${zSpacing.z2};
`;

export const FeatureSubtitle = styled.div`
  color: ${grey.z600};
  font-family: ${fontFamilies.regular};
  font-size: ${fontSizes.z300};
  line-height: 1.4;
`;
